var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIosIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.11 9.627c-.023-2.153 2.014-3.201 2.108-3.25-1.154-1.472-2.944-1.673-3.572-1.688-1.502-.139-2.959.786-3.725.786-.78 0-1.958-.773-3.228-.75-1.634.022-3.164.85-4.002 2.135-1.73 2.62-.44 6.472 1.218 8.59.83 1.037 1.798 2.196 3.067 2.155 1.24-.045 1.704-.693 3.202-.693 1.485 0 1.92.693 3.213.667 1.332-.019 2.17-1.042 2.972-2.09.958-1.188 1.343-2.36 1.358-2.42-.031-.009-2.587-.861-2.612-3.442M11.665 3.296c.667-.73 1.123-1.724.997-2.733-.966.038-2.174.585-2.87 1.3-.616.629-1.165 1.66-1.024 2.63 1.086.071 2.2-.479 2.897-1.197"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosIconGrey);
export default __webpack_public_path__ + "static/media/ios_icon_grey.bd18b0ba.svg";
export { ForwardRef as ReactComponent };